import {useConstructorEnvironment} from "./useConstructorEnvironment";
import {ConstructorEnvironment} from "../data";
import {useSubmitCart} from "./useSubmitCart";
import {useSubmitPreset} from "./useSubmitPreset";
import {useSubmitGamebox} from "./useSubmitGamebox";

export const useConstructorSubmitActon = () => {
    const constructorEnvironment = useConstructorEnvironment();

    const {addToCart} = useSubmitCart();
    const {addToPreset} = useSubmitPreset();
    const {addToGamebox} = useSubmitGamebox();

    switch (constructorEnvironment) {
        case ConstructorEnvironment.gameboxAdmin:
            return addToGamebox;

        case ConstructorEnvironment.presetAdmin:
            return addToPreset;

        case ConstructorEnvironment.cart:
        default:
            return addToCart;
    }
};
